import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=490f5ead"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=490f5ead&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports